import React from 'react';
import { assignIdsToStruc } from '../../../../../utils/helper';
import Ueberpruefung from './content/Ueberpruefung';
import Abruf from './content/Abruf';
// import Abschluss from './content/Abschluss';

export const MittelabrufStructure = () => {
	const STRUC = [
		{ label: 'Überprüfung', content: <Ueberpruefung /> },
		{ label: 'Abruf', content: <Abruf /> },
	];
	return assignIdsToStruc(STRUC);
};
